import damagePolicyGraphQl from '../api/damagePolicyGraphQl';
import actions from '../actions/damagePolicyActions';

async function updateDamagePolicyIfDatesSelected(store) {
    const {listingReducer, tripDetailsReducer, systemReducer} = store.getState();

    if (!tripDetailsReducer.arriveDateText || !tripDetailsReducer.departDateText) {
        return;
    }

    const data = await damagePolicyGraphQl(
        {
            unit: listingReducer.unitApiUrl,
            listingId: listingReducer.listingId,
            pointOfSaleId: systemReducer.siteName,
            arrivalDate: tripDetailsReducer.arriveDateText,
            departureDate: tripDetailsReducer.departDateText,
            adults: tripDetailsReducer.adults
        },
        systemReducer.locale
    );

    if (data && data.quote && data.quote.policies) {
        const damagePolicy = data.quote.policies.find((policy) => {
            return policy.type === 'DAMAGE_LIABILITY';
        });
        store.dispatch({
            type: actions.UPDATE_DAMAGE_POLICY,
            payload: {
                damagePolicy
            }
        });
    }
}

export default updateDamagePolicyIfDatesSelected;
